import moment from "moment";
import React, { type CSSProperties } from "react";
import Skeleton from "react-loading-skeleton";

import SafeECharts from "../../stats/SafeECharts";

moment.locale("en");

interface MonthlyPayoutsGraphProps {
  /** Record of month number (string) to amount in EUR */
  data?: Record<string, number>;
  isLoading?: boolean;
  style?: CSSProperties;
  className?: string;
}

const MonthlyPayoutsGraph: React.FC<MonthlyPayoutsGraphProps> = ({
  data = {},
  isLoading = false,
  style,
  className,
  ...EChartsProps
}) => {
  if (isLoading) return <Skeleton height={style?.height || 400} />;

  const warningColor = getComputedStyle(document.documentElement).getPropertyValue("--warning").trim();

  return (
    <SafeECharts
      {...EChartsProps}
      className={className}
      style={style}
      option={{
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              formatter: ({ value }: { value: string }) => moment(value, "M").format("MMMM"),
            },
          },
        },
        grid: {
          containLabel: true,
          top: 15,
          right: 10,
          left: 10,
          bottom: 10,
        },
        yAxis: {
          type: "value",
          axisLabel: { formatter: (n: number) => n + " €" },
        },
        xAxis: {
          type: "category",
          data: Object.keys(data),
          axisLabel: { formatter: (n: string) => moment(n, "M").format("MMM") },
        },
        series: [
          {
            color: warningColor,
            name: "Paid out",
            type: "bar",
            barWidth: "60%",
            data: Object.values(data),
            tooltip: { valueFormatter: (n: number) => n + " €" },
          },
        ],
      }}
    />
  );
};

export default MonthlyPayoutsGraph;
